import { User } from "@/apis/bff"
import { Service } from "@/types/__generated__/union-types"

export const canUserTakeAppointmentWithService = (user: User, service: Service | undefined): boolean =>
  user.hasMedicalRole || (user.hasNonMedicalRole && service === "ADMINISTRATIVE_REQUEST")
